import classNames from "classnames";
import React, { PureComponent } from "react";

import { ITestable, testAttr } from "@/browser";

import { withFormElement } from "../withFormElement";
import { IStyleSize, IStyleWidth } from "./../../../Style";

interface StyleProps extends IStyleSize, IStyleWidth {}

export interface ILabelProps extends Partial<StyleProps>, ITestable {
  className?: string;
  required?: boolean;
  text?: string;
  flat?: boolean;
  align?: "left" | "right" | "center";
}

class LabelComponent extends PureComponent<ILabelProps> {
  static defaultProps = {
    size: "md",
  } as ILabelProps;

  render() {
    const { className, children, required, text, flat, size, align } = this.props;

    const classes = classNames(className, "el-form-label", {
      "el-form-label--required": required,
      "el-form-label--flat": flat,
      [`el-form-label--size-${size}`]: !!size,
      [`el-form-label--align-${align}`]: !!align,
    });

    return (
      <label className={classes} {...testAttr(this.props, { sufix: "label" })}>
        {text || children}
      </label>
    );
  }
}

export const Label = withFormElement(LabelComponent);
